import { Pie } from '@nivo/pie'
import styles from "./Hub.module.css"


const PieModule = ({ raw }) => {
  const counts = raw.reduce(
    (acc, { accepted = false, admitted = false }) => {
      if (accepted) acc.accepted++;
      else acc.notAccepted++;

      if (admitted) acc.admitted++;
      else acc.notAdmitted++;

      return acc;
    },
    { accepted: 0, notAccepted: 0, admitted: 0, notAdmitted: 0 }
  );

  const data = [
    { id: 'accepted', label: 'accepted', value: counts.accepted },
    { id: 'not accepted', label: 'not accepted', value: counts.notAccepted },
    { id: 'admitted', label: 'admitted', value: counts.admitted },
    { id: 'not admitted', label: 'not admitted', value: counts.notAdmitted },
  ];

  const palette = [
    '#8EC4E3',
    '#69B0DA',
    '#449dd1',
    '#367DA7',
    '#285E7D',
  ];



  return (
    <Pie
      data={data}
      colors={palette}
      width={200}
      height={200}
      margin={{
        top: 8,
        right: 8,
        bottom: 8,
        left: 8,
      }}
      innerRadius={0.5}
      enableArcLinkLabels={false}
      padAngle={0.6}
      cornerRadius={2}
      activeOuterRadiusOffset={8}

      enableArcLabels={true}
      // make them pure white
      arcLabelsTextColor="#ffffff"
      // and increase font size via theme override
      theme={{
        labels: {
          text: {
            fontSize: 18,
            fontWeight: "bold"
          },
        },
      }}
    />
  )
};

export default PieModule;